module.exports = __webpack_public_path__ + "static/media/author9.ccd1d5b6.jpg";